module.exports = __webpack_public_path__ + "img/action-logo-block.3f48f7b6.svg";